import { render, staticRenderFns } from "./ssr-detail-load.vue?vue&type=template&id=333d00b8&scoped=true"
import script from "./ssr-detail-load.vue?vue&type=script&lang=js"
export * from "./ssr-detail-load.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d00b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333d00b8')) {
      api.createRecord('333d00b8', component.options)
    } else {
      api.reload('333d00b8', component.options)
    }
    module.hot.accept("./ssr-detail-load.vue?vue&type=template&id=333d00b8&scoped=true", function () {
      api.rerender('333d00b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/ssr-detail-load.vue"
export default component.exports